import { useEffect, useRef, useState } from 'react';
import { GeoClass } from '../../../interface/response/GeoFiltersResponse';

interface SearchProps {
  data?: any[];
  searchKeys?: string[];
  onFilteredData?: (filtered: GeoClass[]) => void;
  placeholder?: string;
  className?: string;
}

const Search: React.FC<SearchProps> = ({ data, searchKeys, onFilteredData, placeholder, className }) => {
  const [query, setQuery] = useState('');
  const searchKeysRef = useRef(searchKeys);

  useEffect(() => {
    searchKeysRef.current = searchKeys;
  }, [searchKeys]);

  useEffect(() => {
    const toLowerCaseQuery = query.toLowerCase();
    const filteredData =
      data?.filter((item) =>
        searchKeysRef.current?.some((key) => String(item[key]).toLowerCase().includes(toLowerCaseQuery)),
      ) || [];
    onFilteredData?.(filteredData);
  }, [query, data, searchKeysRef, onFilteredData]);

  return (
    <div className="search_wrapper">
      <input
        type="text"
        placeholder={placeholder}
        className={`search_input ${className}`}
        name="search"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
      />
      {query && (
        <span className="clear_search" onClick={() => setQuery('')}>
          &times;
        </span>
      )}
    </div>
  );
};

export default Search;
